import { ComponentPropsWithRef } from "react";
import { FieldValues, SubmitHandler, UseFormReturn } from "react-hook-form";
import styled, { CSSProperties } from "styled-components";

// TEXT

// STYLES
export const FormHeader = styled.div`
  display: flex;
  flex-flow: column;
  gap: 1.5rem;
`;

export const FormButtons = styled.div<{
  $justify?: CSSProperties["justifyContent"];
}>`
  display: flex;
  justify-content: ${({ $justify = "flex-end" }) => $justify};
  align-items: center;
  gap: 1.5rem;
`;

// DATA

// TYPES
export interface Props<T extends FieldValues> extends Omit<
  ComponentPropsWithRef<"form">,
  "onSubmit"
> {
  onSubmit: SubmitHandler<T>;
  formMethods: UseFormReturn<T>;
  validate?: boolean;
}

// CONSTANTS

// FUNCTIONS

// ASSETS
